// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://lineascan.build/address/0x3c6Cd9Cc7c7a4c2Cf5a82734CD249D7D593354dA
export const ETH__USD = '0x3c6Cd9Cc7c7a4c2Cf5a82734CD249D7D593354dA';

// https://lineascan.build/address/0x8dF01C2eFed1404872b54a69f40a57FeC1545998
export const LINK__USD = '0x8dF01C2eFed1404872b54a69f40a57FeC1545998';

// https://lineascan.build/address/0x8eCE1AbA32716FdDe8D6482bfd88E9a0ee01f565
export const WSTETH__USD = '0x8eCE1AbA32716FdDe8D6482bfd88E9a0ee01f565';

// https://lineascan.build/address/0xdE14081b6bd39230EcA7Be1137413b7b87B07C07
export const FOXY__USD = '0xdE14081b6bd39230EcA7Be1137413b7b87B07C07';

// https://lineascan.build/address/0xC4bF21Ab46bd22Cf993c0AAa363577bD2Af83544
export const weETH__ETH = '0xC4bF21Ab46bd22Cf993c0AAa363577bD2Af83544';

// https://lineascan.build/address/0x8b65a2BA86D9aE89bFE4EA68e97B20e45ab05623
export const savBTC__avBTC_Exchange_Rate = '0x8b65a2BA86D9aE89bFE4EA68e97B20e45ab05623';

// https://lineascan.build/address/0x8b7fAC4A99daDa67C661D4854B2284c7A64722f4
export const PCE_Price_Index_Level = '0x8b7fAC4A99daDa67C661D4854B2284c7A64722f4';

// https://lineascan.build/address/0xe3B01C1A61eF2F13a7a24F060a2d53006d91e38a
export const savETH__avETH_Exchange_Rate = '0xe3B01C1A61eF2F13a7a24F060a2d53006d91e38a';

// https://lineascan.build/address/0x1E2286815B3D628128fbaa0F213fD53Dea9E015E
export const Real_GDP_Level = '0x1E2286815B3D628128fbaa0F213fD53Dea9E015E';

// https://lineascan.build/address/0x5C5Ee01b351b7ef0b16Cfd59E93F743E0679d7bC
export const agETH_ETH_Exchange_Rate = '0x5C5Ee01b351b7ef0b16Cfd59E93F743E0679d7bC';

// https://lineascan.build/address/0xe5aCa1a31aD6fC61E30Ab8E4a19a9445884A1EDE
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0xe5aCa1a31aD6fC61E30Ab8E4a19a9445884A1EDE';

// https://lineascan.build/address/0x9ECEa805F9DbeeFE8EdB7e3ee08995fF65828d7a
export const USD1__USD = '0x9ECEa805F9DbeeFE8EdB7e3ee08995fF65828d7a';

// https://lineascan.build/address/0x4C2f2CD982DD7fF2a607dcEB0B30fae8208D7156
export const osETH__ETH_Exchange_Rate = '0x4C2f2CD982DD7fF2a607dcEB0B30fae8208D7156';

// https://lineascan.build/address/0x1EBA8E11f5Dcc43ae9A8cB7A8346D1d191671BAe
export const inETH__ETH_Exchange_Rate = '0x1EBA8E11f5Dcc43ae9A8cB7A8346D1d191671BAe';

// https://lineascan.build/address/0x09B0a8AFD9185500d7C64FC68338b4C50db6df1d
export const AAVE__USD = '0x09B0a8AFD9185500d7C64FC68338b4C50db6df1d';

// https://lineascan.build/address/0x0956106Bd02f2C7eca0AbDe1d51Fc8050CC41714
export const ultraETHs__ETH_Exchange_Rate = '0x0956106Bd02f2C7eca0AbDe1d51Fc8050CC41714';

// https://lineascan.build/address/0xc834a55fb78dEa866E9cd86047Df0F584B9da339
export const MUSD__USD = '0xc834a55fb78dEa866E9cd86047Df0F584B9da339';

// https://lineascan.build/address/0xc0068A2F7e4847DF9C3A34B27CCc07b7e15e0458
export const COMP__USD = '0xc0068A2F7e4847DF9C3A34B27CCc07b7e15e0458';

// https://lineascan.build/address/0x49768d7ebB7694b1e72546300cCCeD877084d72f
export const xSolvBTC_NAV = '0x49768d7ebB7694b1e72546300cCCeD877084d72f';

// https://lineascan.build/address/0x81F4d3052b034007cb5fA1D4CFb56D0732867f2a
export const AAVE_Network_Emergency_Count_Linea = '0x81F4d3052b034007cb5fA1D4CFb56D0732867f2a';

// https://lineascan.build/address/0xdAad34260E4105702278F225d3d20C453d12065e
export const Real_GDP_Percent_Change_Annual_Rate = '0xdAad34260E4105702278F225d3d20C453d12065e';

// https://lineascan.build/address/0x9165802Ea199C36F85D53A6F71Da6AF5a6EA8951
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x9165802Ea199C36F85D53A6F71Da6AF5a6EA8951';

// https://lineascan.build/address/0x28606F10277Cc2e99e57ae2C55D26860E13A1BBD
export const ARB__USD = '0x28606F10277Cc2e99e57ae2C55D26860E13A1BBD';

// https://lineascan.build/address/0xeeD6246A489f386b10eeB2908239C8529B9b25DD
export const instETH__ETH_Exchange_Rate = '0xeeD6246A489f386b10eeB2908239C8529B9b25DD';

// https://lineascan.build/address/0x8d6ceb62Ce510935792BE737e30f9f61082b72b3
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x8d6ceb62Ce510935792BE737e30f9f61082b72b3';

// https://lineascan.build/address/0xc4194f19E3a0836F6B998394445C6535c50604Ce
export const LINK__ETH = '0xc4194f19E3a0836F6B998394445C6535c50604Ce';

// https://lineascan.build/address/0xEEDF0B095B5dfe75F3881Cb26c19DA209A27463a
export const wrsETH_ETH_Exchange_Rate = '0xEEDF0B095B5dfe75F3881Cb26c19DA209A27463a';

// https://lineascan.build/address/0xAADAa473C1bDF7317ec07c915680Af29DeBfdCb5
export const USDC__USD = '0xAADAa473C1bDF7317ec07c915680Af29DeBfdCb5';

// https://lineascan.build/address/0x452b408b3e2805C109D52C80Bd54Deda239716d1
export const LINEA__USD = '0x452b408b3e2805C109D52C80Bd54Deda239716d1';

// https://lineascan.build/address/0x7A99092816C8BD5ec8ba229e3a6E6Da1E628E1F9
export const BTC__USD = '0x7A99092816C8BD5ec8ba229e3a6E6Da1E628E1F9';

// https://lineascan.build/address/0x9e6c73Ae2b419eb32D5D4380067D8E24785926d3
export const YETH_ETH_Exchange_Rate = '0x9e6c73Ae2b419eb32D5D4380067D8E24785926d3';

// https://lineascan.build/address/0x637cf12017219Dd3A758818eD63185f7acF7D935
export const EUR__USD = '0x637cf12017219Dd3A758818eD63185f7acF7D935';

// https://lineascan.build/address/0x5cC678be64bF599B97131092D7CEf6C30a5271aD
export const M_NAV = '0x5cC678be64bF599B97131092D7CEf6C30a5271aD';

// https://lineascan.build/address/0xB1d9A4Fe9331E28C5588B63343BF064A397aadB8
export const ezETH__ETH = '0xB1d9A4Fe9331E28C5588B63343BF064A397aadB8';

// https://lineascan.build/address/0x5133D67c38AFbdd02997c14Abd8d83676B4e309A
export const DAI__USD = '0x5133D67c38AFbdd02997c14Abd8d83676B4e309A';

// https://lineascan.build/address/0xEF77B4A7D92eBDC89025B8E11916A69BDA6d189c
export const POL__USD = '0xEF77B4A7D92eBDC89025B8E11916A69BDA6d189c';

// https://lineascan.build/address/0x57011f81c93Da4dFb244c80667aAECf8cA9D53Bb
export const ynETH__ETH_Exchange_Rate = '0x57011f81c93Da4dFb244c80667aAECf8cA9D53Bb';

// https://lineascan.build/address/0x0AAC940015d333b8E4f93fcE9c0f6f365d252741
export const SAVUSD__AVUSD_Exchange_Rate = '0x0AAC940015d333b8E4f93fcE9c0f6f365d252741';

// https://lineascan.build/address/0xefCA2bbe0EdD0E22b2e0d2F8248E99F4bEf4A7dB
export const USDT__USD = '0xefCA2bbe0EdD0E22b2e0d2F8248E99F4bEf4A7dB';

// https://lineascan.build/address/0x1FBc7d24654b10c71fd74d3730d9Df17836181EF
export const weETH__eETH_Exchange_Rate = '0x1FBc7d24654b10c71fd74d3730d9Df17836181EF';

// https://lineascan.build/address/0xb71F79770BA599940F454c70e63d4DE0E8606731
export const ezETH__ETH_Exchange_Rate = '0xb71F79770BA599940F454c70e63d4DE0E8606731';

// https://lineascan.build/address/0xB21b5Abc612b8045A33fC421d611D55473E012BD
export const rswETH__ETH_Exchange_Rate = '0xB21b5Abc612b8045A33fC421d611D55473E012BD';

// https://lineascan.build/address/0x3C8A95F2264bB3b52156c766b738357008d87cB7
export const wstETH__stETH_Exchange_Rate = '0x3C8A95F2264bB3b52156c766b738357008d87cB7';

// https://lineascan.build/address/0x921000Dd4faA3Dc53F5Ee1c21Ab6e4211B191C5C
export const YBTC_BTC_Exchange_Rate = '0x921000Dd4faA3Dc53F5Ee1c21Ab6e4211B191C5C';

export const CHAIN_ID = 59144;
